import type { CityConfig } from "../city-template/types";

export const blacksburgVaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Virginia Dept of Health Vital Records", href: "https://www.vdh.virginia.gov/vital-records/", description: "Official Virginia vital records office in Richmond" },
    { label: "Marriage Licenses — Montgomery County Circuit Court Clerk", href: "https://www.montva.com", description: "Montgomery County Circuit Court Clerk — marriage license issuance" },
    { label: "Divorce Records — Montgomery County Circuit Court Clerk", href: "https://www.montva.com", description: "Montgomery County Circuit Court Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of VDH for online vital record orders" },
  ],
  city: "Blacksburg",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "blacksburg-va",
  route: "/cities/blacksburg-va",
  title: "Emergency Passport Blacksburg, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Blacksburg, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Blacksburg, Virginia Tech, Montgomery County, and the New River Valley. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Blacksburg, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Virginia Tech, Montgomery County, or the New River Valley? We help Blacksburg travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Blacksburg%20Virginia%20downtown%20with%20Virginia%20Tech%20campus%20and%20the%20historic%20Hokie%20Stone%20buildings%2C%20the%20Duck%20Pond%20and%20Burruss%20Hall%20visible%2C%20the%20New%20River%20Valley%20backdrop%20with%20rolling%20Appalachian%20mountains%2C%20modern%20university%20town%20with%20historic%20charm%20and%20collegiate%20atmosphere%2C%20warm%20afternoon%20light%20with%20autumn%20foliage%20and%20mountain%20ridges%2C%20professional%20photography%20showcasing%20Southwest%20Virginia%20college%20town%20with%20scenic%20Blue%20Ridge%20foothills%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape%20with%20collegiate%20architecture%20and%20mountain%20backdrop&width=1800&height=700&seq=blacksburg-va-hero-001&orientation=landscape",
  heroImageAlt: "Blacksburg Virginia downtown with Virginia Tech campus and Hokie Stone buildings against the New River Valley",
  geoPosition: "37.2296;-80.4139",
  geoPlacename: "Blacksburg, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 250 miles northeast of Blacksburg via I-81 and I-66",
  },
  nearbyCitiesZips: [
    { name: "Blacksburg", zips: "24060, 24061, 24062, 24063" },
    { name: "Montgomery County", zips: "24060, 24061, 24062, 24063, 24073, 24079, 24084, 24085, 24087" },
    { name: "Christiansburg", zips: "24068, 24073" },
    { name: "Radford", zips: "24141, 24142, 24143" },
    { name: "Pulaski", zips: "24301" },
    { name: "Dublin", zips: "24084" },
    { name: "Floyd", zips: "24091" },
    { name: "Giles County", zips: "24301, 24382, 24134" },
    { name: "Roanoke", zips: "24001, 24002, 24003, 24004, 24005, 24006, 24007, 24008, 24009, 24010, 24011, 24012, 24013, 24014, 24015, 24016, 24017, 24018, 24019, 24020, 24022, 24023, 24024, 24025, 24026, 24027, 24028, 24029, 24030, 24031, 24032, 24033, 24034, 24035, 24036, 24037, 24038, 24040, 24042, 24043, 24044, 24045, 24048, 24050, 24054, 24055, 24059, 24060, 24061, 24062, 24063, 24064, 24065, 24066, 24067, 24068, 24070, 24072, 24073, 24077, 24078, 24079, 24083, 24084, 24085, 24086, 24087, 24088, 24089, 24090, 24091, 24092, 24095" },
    { name: "Lynchburg", zips: "24501, 24502, 24503, 24504, 24505, 24506, 24514, 24515" },
    { name: "Charlottesville", zips: "22901, 22902, 22903, 22911, 22936, 22947, 22972, 22974" },
    { name: "Harrisonburg", zips: "22801, 22802, 22803, 22807" },
    { name: "Danville", zips: "24540, 24541, 24543, 24544" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Winchester", zips: "22601, 22602, 22603, 22604" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the New River Valley and Virginia Tech" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "New River Valley Hub", desc: "Serving Blacksburg, Virginia Tech, Christiansburg, Radford, and the New River Valley" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Roanoke VA passport services", route: "/cities/roanoke-va" },
    { name: "Lynchburg VA passport services", route: "/cities/lynchburg-va" },
    { name: "Charlottesville VA passport services", route: "/cities/charlottesville-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Blacksburg remotely via secure courier. We do not have a walk-in office in Blacksburg — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Blacksburg and New River Valley travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Blacksburg and the New River Valley including Montgomery County, Christiansburg, Radford, Pulaski, Dublin, Floyd, and the greater New River Valley region",
  serviceAreaIntro: "From the Virginia Tech campus and Hokie Stone buildings to the New River Valley's rolling Appalachian foothills, from the vibrant downtown of Blacksburg to the historic towns of Christiansburg and Radford, from the mountain communities of Floyd and Pulaski to the growing neighborhoods of Dublin and Giles County — Fast Passport Center serves every corner of Blacksburg and the New River Valley. We regularly help travelers from Virginia Tech, Radford University, and the greater Montgomery County area get their passports fast.",
  nearbyCitiesIntro: "We serve all Blacksburg neighborhoods and the New River Valley including Montgomery County, Christiansburg, Radford, Pulaski, Dublin, Floyd, Giles County, and the surrounding Appalachian region.",
  howItWorksIntro: "Most Blacksburg travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Blacksburg travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Blacksburg and New River Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Blacksburg? Here are the most common ones we hear from New River Valley travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Blacksburg international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Dr. Sarah K.",
      location: "Blacksburg, VA",
      rating: 5,
      text: "As a Virginia Tech professor, I needed an emergency passport for an international conference in Berlin with 5 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS in downtown Blacksburg and everything was flawless. This service is essential for the university community.",
      service: "Emergency Passport",
    },
    {
      name: "James M.",
      location: "Christiansburg, VA",
      rating: 5,
      text: "I live in Christiansburg and was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience for New River Valley families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Rachel T.",
      location: "Radford, VA",
      rating: 5,
      text: "First passports for my two kids before a family trip to Costa Rica. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 6 days. For Radford and New River Valley families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "David P.",
      location: "Blacksburg, VA",
      rating: 5,
      text: "Lost my passport 4 days before a study abroad departure. I was a Virginia Tech student in absolute panic. Fast Passport Center had a replacement in my hands in 36 hours. They saved my entire semester abroad. Blacksburg students need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "blacksburg-va-1",
      name: "Blacksburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Blacksburg",
      state: "VA",
      zip: "24060",
      phone: "(540) 552-3291",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Blacksburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Blacksburg facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "blacksburg-va-2",
      name: "Christiansburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Christiansburg",
      state: "VA",
      zip: "24073",
      phone: "(540) 382-7345",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Christiansburg, south of Blacksburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Christiansburg and southern Montgomery County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "blacksburg-va-3",
      name: "Radford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Radford",
      state: "VA",
      zip: "24141",
      phone: "(540) 639-2221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Radford, west of Blacksburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Radford and Radford University. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "blacksburg-va-4",
      name: "Pulaski Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Pulaski",
      state: "VA",
      zip: "24301",
      phone: "(540) 980-1131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Pulaski, southwest of Blacksburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Pulaski County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "blacksburg-va-5",
      name: "Montgomery County Clerk",
      type: "County Clerk",
      address: "1 E Main St",
      city: "Christiansburg",
      state: "VA",
      zip: "24073",
      phone: "(540) 382-5760",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Christiansburg, Montgomery County",
      website: "https://www.montva.com",
      websiteLabel: "Montgomery County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "blacksburg-va-6",
      name: "Virginia Tech",
      type: "Campus Resource",
      address: "800 Drillfield Dr",
      city: "Blacksburg",
      state: "VA",
      zip: "24061",
      phone: "(540) 231-6000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Blacksburg, Virginia Tech campus",
      website: "https://www.vt.edu",
      websiteLabel: "Virginia Tech",
      notes: "Not a passport acceptance facility, but helpful for students and international program participants. Check with the Global Education Office.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4+ hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Who Can Use It", agency: "Life-or-death emergencies only — proof required", fpc: "All travelers — urgent, expedited, or planned" },
    { feature: "Cost vs Resellers", agency: "Government fee only — no courier service", fpc: "30–100% less than FedEx, Staples, and other resellers" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Blacksburg photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at New River Valley acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Blacksburg applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Blacksburg families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Blacksburg travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Blacksburg or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Blacksburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Blacksburg before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Blacksburg for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the New River Valley and Virginia Tech." },
    { q: "How fast can I renew my passport in Blacksburg?", a: "Fast Passport Center offers fast passport renewal in Blacksburg in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Blacksburg?", a: "The nearest regional passport agency to Blacksburg is the Washington Passport Agency, located approximately 250 miles northeast in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Blacksburg." },
    { q: "Can I get a same-day passport appointment near Blacksburg?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Blacksburg residents." },
    { q: "Can I expedite a child passport in Blacksburg?", a: "Yes. Fast Passport Center expedites child passports in Blacksburg for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Blacksburg and New River Valley families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Blacksburg with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Blacksburg?", a: "With Fast Passport Center's emergency courier service, Blacksburg travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Blacksburg?", a: "Popular options include the Blacksburg Post Office (24060), Christiansburg Post Office (24073), Radford Post Office (24141), and Pulaski Post Office (24301). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Christiansburg, Radford, or Pulaski?", a: "We serve the entire New River Valley including Christiansburg, Radford, Pulaski, Dublin, Floyd, and Giles County. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Blacksburg?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Blacksburg", address: "1325 University City Blvd, Blacksburg, VA 24060", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Blacksburg", address: "1625 N Main St, Blacksburg, VA 24060", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart — Christiansburg", address: "1320 N Franklin St, Christiansburg, VA 24073", hours: "Mon-Sun: 7AM-10PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Radford", address: "1010 E Main St, Radford, VA 24141", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Christiansburg", address: "1555 N Franklin St, Christiansburg, VA 24073", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Blacksburg", address: "1201 University City Blvd, Blacksburg, VA 24060", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Blacksburg",
      address: "2601 S Main St, Blacksburg, VA 24060",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Christiansburg",
      address: "2400 S Main St, Christiansburg, VA 24073",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Pulaski",
      address: "480 E Main St, Pulaski, VA 24301",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Pulaski County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ROA",
      name: "Roanoke-Blacksburg Regional Airport",
      distance: "Approximately 30 miles north of Blacksburg via US-460",
      address: "5202 Aviation Dr NW, Roanoke, VA 24012",
      note: "The closest airport to Blacksburg. Domestic flights to major hubs. Accessible via US-460.",
      flightUrl: "https://www.flyroa.com/",
      flightLabel: "ROA Airport",
      featured: true,
    },
    {
      code: "LYH",
      name: "Lynchburg Regional Airport",
      distance: "Approximately 85 miles east of Blacksburg via US-460",
      address: "350 Terminal Dr, Lynchburg, VA 24502",
      note: "Regional hub for Central Virginia. Accessible via US-460.",
      flightUrl: "https://www.flylyh.com/",
      flightLabel: "LYH Airport",
      featured: false,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Approximately 170 miles east of Blacksburg via I-81 and I-64",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "Regional hub for Central Virginia. Accessible via I-81 and I-64.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
    {
      code: "CHO",
      name: "Charlottesville-Albemarle Airport",
      distance: "Approximately 110 miles northeast of Blacksburg via I-81 and I-64",
      address: "1000 Bowen Loop, Charlottesville, VA 22911",
      note: "Regional hub for Central Virginia. Accessible via I-81 and I-64.",
      flightUrl: "https://www.gocho.com/",
      flightLabel: "CHO Airport",
      featured: false,
    },
  ],
};